import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchClientProfileSettings } from '../actions';
import { ProfileSetting } from '../types';

export const useFetchClientProfileSettings = (profileSettings: ProfileSetting[]) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch<any>(fetchClientProfileSettings(profileSettings));
  }, []);
};
